import { Form } from "antd";
import { useGiftcardsListing } from "../../context/GiftcardsListingContext";
import { INITIAL_GIFTS_SEARCH } from "../../constants";
import { useDebounceFn } from "src/hooks/useDebounce";
import CategoriesField from "./components/CategoriesField/CategoriesField";

export default function Filters() {
  const { setFilters } = useGiftcardsListing();
  const debouncedSetFilters = useDebounceFn(setFilters, 300);

  return (
    <Form initialValues={INITIAL_GIFTS_SEARCH} className="w-full" onValuesChange={debouncedSetFilters}>
      <Form.Item name="categoryCode" className="m-0! w-full!">
        <CategoriesField />
      </Form.Item>
    </Form>
  );
}
